import {Button, VStack } from '@chakra-ui/react'
import React from 'react'
import { RiAddCircleFill, RiDashboardFill, RiEyeFill, RiUser3Fill } from 'react-icons/ri'
import {Link,useLocation} from 'react-router-dom'

const Sidebar = () => {
    const location = useLocation();
  return (
    <VStack spacing={'8'} p='16' boxShadow={'-2px 0 10px rgba(107,70,193,0.5)'}>
        <LinkButton Icon={RiDashboardFill} Text='Dashboard' url={'dashboard'} active={location.pathname=='/admin/dashboard'}/>
        <LinkButton Icon={RiAddCircleFill} Text='Create Course' url={'createcourse'} active={location.pathname=='/admin/createcourse'}/>
        <LinkButton Icon={RiEyeFill} Text='Courses' url={'courses'} active={location.pathname=='/admin/courses'}/>
        <LinkButton Icon={RiUser3Fill} Text='Users' url={'users'} active={location.pathname=='/admin/users'}/>
    </VStack>
  )
}

export default Sidebar

function LinkButton ({url,Icon,Text,active}){
    return(
        <Link to={`/admin/${url}`}>
            <Button fontSize={'larger'} colorScheme={active?'pink':''} variant='outline'>
                <Icon style={{margin:'4px'}}/>
                {Text}
            </Button>
        </Link>
    )
}